import apiClient from "./config";
import { AUTH_ENDPOINTS } from "./endpoints";

/**
 * Register Method
 */
export const postFakeRegister = (data) => apiClient.create(AUTH_ENDPOINTS.REGISTER, data);

/**
 * Login Method
 */
export const postFakeLogin = (data) => apiClient.create(AUTH_ENDPOINTS.LOGIN, data);

/**
 * JWT Login Method
 */
export const postJwtLogin = (data) => {
  return apiClient.create(AUTH_ENDPOINTS.LOGIN, data)
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

/**
 * Register Method (JWT)
 */
export const postJwtRegister = (data) => {
  return apiClient.create(AUTH_ENDPOINTS.REGISTER, data)
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

/**
 * Forget Password
 */
export const postFakeForgetPwd = (data) => apiClient.create(AUTH_ENDPOINTS.PASSWORD_FORGET, data);

/**
 * JWT Forget Password
 */
export const postJwtForgetPwd = (data) => apiClient.create(AUTH_ENDPOINTS.JWT_PASSWORD_FORGET, data);

/**
 * Edit Profile (JWT)
 */
export const postJwtProfile = (data) => apiClient.create(AUTH_ENDPOINTS.EDIT_PROFILE, data);

/**
 * Edit Profile (Fake)
 */
export const postFakeProfile = (data) => apiClient.update(AUTH_ENDPOINTS.EDIT_USER_PROFILE + '/' + data.idx, data);

/**
 * Social Login
 */
export const postSocialLogin = (data) => apiClient.create(AUTH_ENDPOINTS.SOCIAL_LOGIN, data);

